<template>
  <b-row>
    <b-col cols="12">
      <compensatory-off-application-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import CompensatoryOffApplicationAddForm from './CompensatoryOffApplicationAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    CompensatoryOffApplicationAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
